export const tituloDeuda = (e) => {
  const partes = [];
  if (e.deuda_matricula > 0) partes.push('matrícula de meses anteriores');
  if (e.deuda_convenio > 0) partes.push('cuotas de convenio impagas');
  if (e.deuda_otros > 0) partes.push('multas');
  if (partes.length === 0) return 'Deuda';
  const ultimo = partes.pop();
  return `Deuda de ${partes.length ? `${partes.join(', ')} y ${ultimo}` : ultimo}`;
};

// La boleta de pago total tiene descuento solo si es menor a la deuda total con mes en curso.
export const boletaConDescuento = (e) =>
  (e.boleta_pago_total?.importe || 0) < (e.total_deuda_vencida || 0) + (e.total_pendiente || 0) - 0.5;

export const leyendaDeudaTotal = (e) => {
  const partes = [];
  if (e.deuda_matricula > 0) partes.push('meses anteriores');
  if (e.deuda_convenio > 0) partes.push('cuotas de convenio impagas');
  if (e.deuda_otros > 0) partes.push('multas');
  if (e.total_pendiente > 0) partes.push('cuota mes en curso');
  return `(${partes.join(' + ')})`;
};

const fmtMonto = (n) => `$${(n || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Mismo criterio que desglose_deuda_texto() del backend (email día 10 y bot).
export const desgloseDeudaTexto = (e) => {
  const corriente = e.total_pendiente || 0;
  const origenes = [['Matrículas impagas', e.deuda_matricula], ['Convenios impagos', e.deuda_convenio], ['Multas impagas', e.deuda_otros]]
    .filter(([, m]) => m > 0);
  const total = origenes.reduce((acc, [, m]) => acc + m, 0) + corriente;
  if (origenes.length === 1) {
    const concepto = origenes[0][0].toLowerCase() + (corriente > 0 ? ' + matrícula del mes actual' : '');
    return { total, nota: null, lineas: [`Concepto: ${concepto}`] };
  }
  return {
    total,
    nota: corriente > 0 ? `(incluye la cuota del mes actual: ${fmtMonto(corriente)})` : null,
    lineas: origenes.map(([n, m]) => `${n}: ${fmtMonto(m)}`),
  };
};
